import { FC } from 'react'
import { StyleTableActionWrapper, StyleActionItem } from './style'

import Svg from '../svg'
interface TableActionProps {
  hasEdit?: boolean
  hasDelete?: boolean
  hasView?: boolean
  onClickEdit?: () => void
  onClickDelete?: () => void
  onClickView?: () => void
}
const TableActions: FC<TableActionProps> = ({
  hasEdit = true,
  hasDelete = true,
  hasView = true,
  onClickEdit,
  onClickView,
  onClickDelete,
}) => {
  return (
    <StyleTableActionWrapper>
      {!!hasEdit && (
        <StyleActionItem
          onClick={(event: any) => {
            event.stopPropagation()
            !!onClickEdit && onClickEdit()
          }}
        >
          <Svg svg="edit" color={'secondary'} size={24} />
        </StyleActionItem>
      )}
      {!!hasView && (
        <StyleActionItem
          onClick={(event: any) => {
            event.stopPropagation()
            !!onClickView && onClickView()
          }}
        >
          <Svg svg="view" color={'primary'} size={24} />
        </StyleActionItem>
      )}
      {!!hasDelete && (
        <StyleActionItem
          onClick={(event: any) => {
            event.stopPropagation()
            !!onClickDelete && onClickDelete()
          }}
        >
          <Svg svg="remove" color={'danger'} size={24} />
        </StyleActionItem>
      )}
    </StyleTableActionWrapper>
  )
}

export default TableActions
